import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from '../../../assets/images/whiky_house/-NYxTxbMew2iGaQCmrZF'
import "./card_slide.css";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShoppingCart,
} from "react-icons/ai";

const NextArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-right-10 shadow-md bg-white p-4 rounded-full md:right-4 top-[47%]">
      <AiOutlineArrowRight />
    </div>
  );
};
const PrevArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-left-10 shadow-md bg-white p-4 rounded-full md:-left-10 left-3 z-50 top-[47%] ">
      <AiOutlineArrowLeft />
    </div>
  );
};

const CardSlide = ({SlideData}) => {

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <div className="mt-14">
        <h1 className=" text-center mb-10 text-[22.5px] px-10 font-['Open_Sans'] font-bold ">
         New Arrivals
        </h1>
      </div>
      <Slider {...settings}>
        {SlideData?.map((item) => (
          <div
            className=" w-full rounded-lg  md:max-w-[16rem] h-[433px] p-4 mt-1 relative border shadow-md mb-14"
            key={item.id}
          >
            <div
              floated={false}
              className="   rounded-none flex-col flex  items-center"
            >
              <img
                src={item.img}
                alt="profile-picture"
                className=" max-h-48 w-full  object-contain"
              />
            </div>
              <div className="text-start pl-1">
                <div className=" ">
                  <div
                    variant=""
                    color="blue-gray"
                    className="mx-2 mt-4 text-lg text-[#8CB0B1]"
                  >
                    {item.price}
                  </div>
                  <div
                    color="blue"
                    className=" text-xs tracking-wide leading-5  text-[18px] mt-2 px-2 textfont"
                    textGradient
                  >
                    {item.cate.slice(0,100)}
                  </div>
                  <div className="px-2 mt-2 text-font text-[14px]">
                    {item.label}
                  </div>
                </div>
                <div className="px-2 mt-3 ">
                  <button
                    class="self-start btn2 border-[#DEC092] w-full  py-3 relative text-[14px] border e uppercase font-semibold tracking-wider leading-none overflow-hidden hover:text-white"
                    type="button"
                  >
                    <span class="absolute inset-0 bg-[#DEC092]"></span>
                    <span class="absolute inset-0 flex justify-center items-center text-[14px] font-bold">
                      Quick Shop
                    </span>
                    Quick Shop
                  </button>
                </div>
              </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default CardSlide;
